// Иконки меню из прототипа.
const p = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  'aria-hidden': true,
} as const;

export type IconName = 'cases' | 'patients' | 'new' | 'board' | 'partners' | 'users' | 'orgs' | 'audit';

export function Icon({ name }: { name: IconName }) {
  switch (name) {
    case 'cases':
      return (
        <svg {...p}>
          <rect x="4" y="4" width="16" height="16" rx="3" />
          <path d="M8 9h8M8 13h8M8 17h5" />
        </svg>
      );
    case 'patients':
      return (
        <svg {...p}>
          <circle cx="12" cy="8" r="3.5" />
          <path d="M5 20c.8-3.6 3.5-5.5 7-5.5s6.2 1.9 7 5.5" />
        </svg>
      );
    case 'new':
      return (
        <svg {...p}>
          <path d="M12 5v14M5 12h14" />
        </svg>
      );
    case 'board':
      return (
        <svg {...p}>
          <rect x="3" y="4" width="5" height="16" rx="1.5" />
          <rect x="10" y="4" width="5" height="11" rx="1.5" />
          <rect x="17" y="4" width="4" height="7" rx="1.5" />
        </svg>
      );
    case 'partners':
      return (
        <svg {...p}>
          <path d="M4 20V9l8-5 8 5v11" />
          <path d="M10 20v-5h4v5M12 8v4M10 10h4" />
        </svg>
      );
    case 'users':
      return (
        <svg {...p}>
          <circle cx="9" cy="8" r="3.2" />
          <path d="M3 19c.6-3 2.9-4.8 6-4.8s5.4 1.8 6 4.8" />
          <path d="M16 5.5a3 3 0 0 1 0 5.6M18 14.5c1.6.6 2.6 2 3 4" />
        </svg>
      );
    case 'orgs':
      return (
        <svg {...p}>
          <rect x="4" y="3" width="10" height="18" rx="1.5" />
          <path d="M14 9h5a1 1 0 0 1 1 1v11H14M7 7h4M7 11h4M7 15h4" />
        </svg>
      );
    case 'audit':
      return (
        <svg {...p}>
          <rect x="5" y="3" width="14" height="18" rx="2" />
          <path d="M9 8h6M9 12h6M9 16h4" />
        </svg>
      );
  }
}

export function BrandMark() {
  return (
    <svg className="brand-mark" viewBox="0 0 34 34" aria-hidden="true">
      <rect width="34" height="34" rx="9" fill="#B9405A" />
      <path
        d="M10 11c0-2 1.6-3.2 3.6-3.2 1.4 0 2.3.6 3.4.6s2-.6 3.4-.6c2 0 3.6 1.2 3.6 3.2 0 3.5-1.4 5-1.9 8.3-.4 2.9-.9 6.7-2.4 6.7-1.6 0-1.5-5.2-2.7-5.2s-1.1 5.2-2.7 5.2c-1.5 0-2-3.8-2.4-6.7C11.4 16 10 14.5 10 11z"
        fill="#fff"
      />
    </svg>
  );
}

export function PlusIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="M12 5v14M5 12h14" />
    </svg>
  );
}
